var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableUsers',{attrs:{"users":_vm.users},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }